<template>
  <div class="substitutesComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2">
        <v-flex xs8>
          <v-text-field v-model="requestSearch" :label="$t('general.search')" clearable append-outer-icon="search"></v-text-field>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-dialog
            persistent
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                round
                outline
                v-on="on"
              >
                <v-icon left>person</v-icon>
                {{$t('substitutes.add')}}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{$t('substitutes.add')}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <v-form
                    lazy-validation
                    ref="form"
                    v-model="valid"
                  >
                    <v-autocomplete
                      v-model="editedItem.user_id"
                      :rules="rules.required"
                      :items="filterUsers"
                      item-text="name"
                      item-value="id"
                      :label="$t('substitutes.assign')"
                      :error-messages="errors.user_id"
                    >
                    </v-autocomplete>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close"
                >
                  {{$t('general.close')}}
                </v-btn>
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  color="primary"
                  round
                  depressed
                  @click="save"
                >
                  {{$t('general.submit')}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-data-table
        class="elevation-2"
        :headers="headers"
        :search="requestSearch"
        :items="substitutes"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
      >
      <template v-slot:headers="props">
        <tr class="bg-heavy-rain">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            <h2 class="font-weight-black primary--text mb-0">
              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text }}
            </h2>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td width="60px">{{props.item.id}}</td>
          <td class="text-sm-center">{{props.item.user.name}}</td>
          <td width="200px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                outline
                icon
                color="error"
                v-on="on"
                @click="removed(props.item)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
              </template>
              <span>{{$t('general.delete')}}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      </v-data-table>
      <v-dialog
        persistent
        v-model="removeDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{$t('general.deleteElement')}}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{$t('general.deleteElementQuestion')}}</p>
            <p class="font-weight-black"><span class="error--text">{{$t('general.name')}}: </span>{{removedItem.user.name}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{$t('general.close')}}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="removeItem(removedItem)"
            >
              {{$t('general.delete')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'substitutesComponent',
  data () {
    return {
      userLogged: {
        roles: [
          {
            id: null
          }
        ],
        company: [
          {
            id: null
          }
        ]
      },
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      dialog: false,
      removeDialog: false,
      valid: true,
      removedItem: {
        user: {
          name: ''
        },
        area: {
          name: ''
        }
      },
      originalItem: {},
      editedItem: {
        id: 0,
        user_id: 0,
        gst_validators_id: 0
      },
      defaultItem: {
        id: 0,
        user_id: 0,
        gst_validators_id: 0
      },
      users: [],
      substitutes: [],
      loading: true,
      loadingItems: true,
      errors: {},
      requestSearch: ''
    }
  },
  computed: {
    heading () {
      return this.$t('general.substitutes')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-user-friends fa-fw icon-color'
    },
    filterUsers () {
      return this.users.filter(item => item.company.length !== 0 && item.company[0].id === this.userLogged.company[0].id)
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('substitutes.name'),
          align: 'center',
          value: 'user.name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    rules () {
      return this.$validationRules()
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    userLogged () {
      if (this.userLogged.company[0].id !== null) {
        this.$emit('substitutesGet', {id: this.userLogged.company[0].id, context: this})
      }
    },
    '$store.state.userLogged' () {
      this.getLogged()
    }
  },
  created () {
    this.getLogged()
    this.initialize()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    removed (item) { // set the item that want to remove and open the dialog
      this.removedItem = item
      this.removeDialog = true
    },
    removeItem (item) { // change the status of the users to '0'
      const index = this.substitutes.indexOf(item)
      this.loading = true
      this.delete(item, index)
    },
    close () { // close the dialog and re-assing default values
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.loading = false
      this.$refs.form.resetValidation()
      this.errors = {}
    },
    closeRemove () {
      this.removeDialog = false
      this.loading = false
    },
    save () { // evaluate the form and save de values
      if (this.$refs.form.validate()) {
        this.loading = true
        this.post()
      }
    },
    initialize () {
      this.$emit('usersGet', {context: this})
    },
    post () {
      this.$emit('post', {item: this.editedItem, context: this})
    },
    delete (item, index) {
      this.$emit('delete', {item: item, index: index, context: this})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/substitutes.component.vue